import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import RevealNews from "./reveal-news"

const NewsPosts = () => {
  const data = useStaticQuery(graphql`
    query NewsQuery {
      wpgraphql {
        cptNews (first: 500) {
          nodes {
            title
            excerpt
            featuredImage {
              node {
                altText
                sourceUrl
                imageFile {
                  childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
            acf_news {
              newsDate
              buttonText
              buttonUrl
            }
          }
        }
      }
    }
  `)

  // Sort by newsDate (newest first)
  const sortedNodes = data.wpgraphql.cptNews.nodes.sort((a, b) => {
    const dateA = new Date(a.acf_news.newsDate)
    const dateB = new Date(b.acf_news.newsDate)
    return dateB.getTime() - dateA.getTime()
  })

  return (
    <article>
      {sortedNodes.map((items, i) => (
        <RevealNews items={items} key={i}></RevealNews>
      ))}
    </article>
  )
}

export default NewsPosts
